"use strict";

exports.__esModule = true;
exports.CycleSplitterDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CycleSplitter = require("./CycleSplitter");
var _CycleSplitterBody = require("./CycleSplitterBody");
var _PlantStateActivities = require("../../PlantStateActivities");
var _DeviceContext = require("../../Device/DeviceContext");
var _ClassificationPopupWidget = require("../ClassificationPopup/ClassificationPopupWidget");
var _utils = require("../ClassificationPopup/utils");
var _Env = require("../../Env");
var _excluded = ["plantStateActivities", "classification", "isOpen", "onClose", "device", "env"];
var _dec, _dec2, _class, _CycleSplitterDialog;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var SplitterDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "CycleSplitterDialog__SplitterDialog",
  componentId: "sc-1c89e37-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);

/**
 * Shows a cycle splitter in a dialog.
 */
var CycleSplitterDialog = exports.CycleSplitterDialog = (_dec = _DeviceContext.DeviceContext.withContext, _dec2 = _Env.EnvContext.withContext, _dec(_class = _dec2(_class = (_CycleSplitterDialog = /*#__PURE__*/function (_Component) {
  function CycleSplitterDialog() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isCurrentCycle: false,
      showDialog: false
    };
    _this.splitCycle = function (parts) {
      if (_this.state.isCurrentCycle) {
        _this.props.onSplit(parts.slice(0, parts.length - 1));
      } else {
        _this.props.onSplit(parts);
      }
      _this.props.onClose();
    };
    _this.onClickNoButton = function () {
      _this.setState({
        showDialog: false
      });
    };
    _this.onClickYesButton = function (parts) {
      _this.setState({
        showDialog: false
      });
      _this.splitCycle(parts);
    };
    return _this;
  }
  _inheritsLoose(CycleSplitterDialog, _Component);
  CycleSplitterDialog.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var cycles = props.cycles,
      selectedCycle = props.classification;
    var currentCycle = cycles[cycles.length - 1];
    return {
      isCurrentCycle: [selectedCycle].includes(currentCycle)
    };
  };
  var _proto = CycleSplitterDialog.prototype;
  _proto.onSplit = function onSplit(parts) {
    if ((0, _utils.checkIfSelectedCyclesOverstepTime)(parts, this.props.env.warningClassificationTime)) {
      this.setState({
        showDialog: true
      });
    } else {
      this.splitCycle(parts);
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      plantStateActivities = _this$props.plantStateActivities,
      classification = _this$props.classification,
      isOpen = _this$props.isOpen,
      onClose = _this$props.onClose,
      device = _this$props.device,
      env = _this$props.env,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var showDialog = this.state.showDialog;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CycleSplitter.CycleSplitter, {
      plantStateActivities: plantStateActivities,
      classification: classification
    }, function (_ref) {
      var classification = _ref.classification,
        parts = _ref.parts,
        disableSplit = _ref.disableSplit,
        onChange = _ref.onChange;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showDialog && /*#__PURE__*/_react["default"].createElement(_ClassificationPopupWidget.ClassificationPopupWidget, {
        onClickNoButton: _this2.onClickNoButton,
        onClickYesButton: function onClickYesButton() {
          return _this2.onClickYesButton(parts);
        },
        warningClassificationTime: env.warningClassificationTime
      }), /*#__PURE__*/_react["default"].createElement(SplitterDialog, _extends({
        icon: _icons.IconNames.SPLIT_COLUMNS,
        title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "CycleSplitterDialog.dialogTitle",
          defaultMessage: "Split Cycles"
        }),
        style: {
          width: 800
        },
        isOpen: isOpen,
        isCloseButtonShown: false
      }, extra), /*#__PURE__*/_react["default"].createElement("section", {
        className: _core.Classes.DIALOG_BODY
      }, /*#__PURE__*/_react["default"].createElement(_CycleSplitterBody.CycleSplitterBody, {
        plantStateActivities: plantStateActivities,
        classification: classification,
        parts: parts,
        onChange: onChange,
        shouldNotClassifyLastSplit: _this2.state.isCurrentCycle,
        device: device
      })), /*#__PURE__*/_react["default"].createElement("footer", {
        className: _core.Classes.DIALOG_FOOTER
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.DIALOG_FOOTER_ACTIONS
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        large: true,
        icon: _icons.IconNames.SPLIT_COLUMNS,
        intent: _core.Intent.PRIMARY,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "CycleSplitterDialog.splitButton.text",
          defaultMessage: "Split"
        }),
        "data-testid": "CycleSplitterDialog.splitButton",
        onClick: function onClick() {
          return _this2.onSplit(parts);
        },
        disabled: disableSplit
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        large: true,
        minimal: true,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "CycleSplitterDialog.cancelButton.text",
          defaultMessage: "Cancel"
        }),
        onClick: onClose
      })))));
    }));
  };
  return CycleSplitterDialog;
}(_react.Component), _CycleSplitterDialog.defaultProps = {
  device: undefined,
  env: undefined
}, _CycleSplitterDialog)) || _class) || _class);